import { doorSettingsStateStore } from './redux-service';
import { loadDoorSettingsState } from './localStorage-service';
const aaecState = require('../../../json/state/aaec-state.json');

export const unitConvertService = (() => {

	let doorState = aaecState;
	if (loadDoorSettingsState() !== undefined) {
		doorState = loadDoorSettingsState();
	}

	const $unitCodePicker 		 	= $( ".unit-picker" ); // Switch input metric/Imperial unit
	const $doorWidthInputSlider  	= $( "input#door-width" );
	const $doorHeightInputSlider 	= $( "input#door-height" );
	const meterRangeMarkersHeight	= "<option>2</option><option>2.5</option><option>3</option><option>3.5</option><option>4</option><option>4.5</option><option>5</option><option>5.5</option><option>6</option>";
	const footRangeMarkersHeight 	= "<option>6</option><option>7</option><option>8</option><option>9</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option>";
	const meterRangeMarkersWidth 	= "<option>2</option><option>2.5</option><option>3</option><option>3.5</option><option>4</option><option>4.5</option><option>5</option><option>5.5</option><option>6</option><option>6.5</option><option>7</option><option>7.5</option><option>8</option>";
	const footRangeMarkersWidth	 	= "<option>6</option><option>7</option><option>8</option><option>9</option><option>10</option><option>11</option><option>12</option><option>13</option><option>14</option><option>15</option><option>16</option><option>17</option><option>18</option><option>19</option><option>20</option><option>21</option><option>22</option><option>23</option><option>24</option><option>25</option><option>26</option>";
	let unitCodePickerValue 	 	= doorState.unit;
	let currentUnit				 	= doorState.unit;

	// On first load check from doorState and set rangeslider to either metric or imperial unit
	if ( currentUnit == "imperial" ) {
		updateRangeSliderToImperial();
	} else if ( currentUnit == "metric") {
		updateRangeSliderToMetric();
	}

	// Unit Change
	$unitCodePicker.on( 'click', function ( e ) {
		e.stopPropagation();
		checkSelectedUnit();
	});

	function checkSelectedUnit() {
		if ($unitCodePicker.prop('checked')) {
			unitCodePickerValue = 'imperial';
			doorSettingsStateStore.dispatch({ type: 'CHANGE_UNIT', unit: unitCodePickerValue });
		} else {
			unitCodePickerValue = 'metric';
			doorSettingsStateStore.dispatch({ type: 'CHANGE_UNIT', unit: unitCodePickerValue });
		}
		unitsConverter( unitCodePickerValue );
	}

	function unitsConverter( updatedUnitCodePickerValue ) {
		let doorHeightValue = $doorHeightInputSlider.val();
		let doorWidthValue = $doorWidthInputSlider.val();

		// check if selected unit is uppdated
		if ( updatedUnitCodePickerValue != currentUnit ) {
			if ( updatedUnitCodePickerValue == "imperial" ) {
				updateRangeSliderToImperial();
				convertFromMeterToFoot( doorWidthValue, doorHeightValue );
				currentUnit = 'imperial';
			} else if (updatedUnitCodePickerValue == "metric" ) {
				updateRangeSliderToMetric();
				convertFromFootToMeter( doorWidthValue, doorHeightValue );
				currentUnit = 'metric';
			}
		} 
	}

	function convertFromMeterToFoot( doorWidthValue, doorHeightValue ) {
		// Height
		doorHeightValue = Math.round( doorHeightValue * 3.2808 ); // Convert meter to foot
		$doorHeightInputSlider.val( doorHeightValue ); // update input value 
		$( ".door-height-value" ).text( doorHeightValue + " ft" ); // update text
		doorSettingsStateStore.dispatch({ type: 'CHANGE_HEIGHT', height: $doorHeightInputSlider.val() });
		// Width
		doorWidthValue = Math.round( doorWidthValue * 3.2808 ); // Convert meter to foot - round up
		$doorWidthInputSlider.val( doorWidthValue ); // update input value 
		$( ".door-width-value" ).text( doorWidthValue + " ft" ); // update text
		doorSettingsStateStore.dispatch({ type: 'CHANGE_WIDTH', width: $doorWidthInputSlider.val() });
	};

	// Update input settings to foot
	function updateRangeSliderToImperial() {
		$doorWidthInputSlider.attr('min', 6).attr('max', 26).attr('step', 1);
		$( "datalist#door-width-settings" ).html(footRangeMarkersWidth);
		$doorHeightInputSlider.attr('min', 6).attr('max', 20).attr('step', 1);
		$( "datalist#door-height-settings" ).html(footRangeMarkersHeight);
		$('.range-slider').each(function(){
			let $selectorContainer = $(this).find('.range-slider__ticks');
			$selectorContainer.empty();
			$(this).find('datalist option').each(function(){
				let value = $(this).html()
				$selectorContainer.append('<div>' + value + ' ft</div>');
			});
		});
	}

	function convertFromFootToMeter( doorWidthValue, doorHeightValue ) {
		// Height
		doorHeightValue = Math.round( doorHeightValue / 3.2808 ); // Convert foot to meter
		$doorHeightInputSlider.val( doorHeightValue ); // update input value
		$( ".door-height-value" ).text( doorHeightValue + " m" ); // update text
		doorSettingsStateStore.dispatch({ type: 'CHANGE_HEIGHT', height: $doorHeightInputSlider.val() });
		// Width
		doorWidthValue = Math.round( doorWidthValue / 3.2808 ); // Convert foot to meter
		$doorWidthInputSlider.val( doorWidthValue ); // update input value 
		$( ".door-width-value" ).text( doorWidthValue + " m" ); // update text
		doorSettingsStateStore.dispatch({ type: 'CHANGE_WIDTH', width: $doorWidthInputSlider.val() });
	};

	// Update input settings to meter
	function updateRangeSliderToMetric() {
		$doorWidthInputSlider.attr('min', 2).attr('max', 8).attr('step', 0.5);
		$( "datalist#door-width-settings" ).html(meterRangeMarkersWidth);
		$doorHeightInputSlider.attr('min', 2).attr('max', 6).attr('step', 0.5);
		$( "datalist#door-height-settings" ).html(meterRangeMarkersHeight);

		$('.range-slider').each(function(){
			let $selectorContainer = $(this).find('.range-slider__ticks');
			$selectorContainer.empty();
			$(this).find('datalist option').each(function(){
				let value = $(this).html()
				$selectorContainer.append('<div>' + value + ' m</div>');
			});
		});
	}
	
	// Special function
	// If click on preset which has meter as default value
	// and the current unit is imperial
	// update the value in the rangeslider to ft value
	$('.js-preset-btn').on( 'click', function(e) {
		if ( currentUnit == "imperial" ) {
			convertFromMeterToFoot( loadDoorSettingsState().door.properties.width, loadDoorSettingsState().door.properties.height );
			doorSettingsStateStore.dispatch({ type: 'CHANGE_UNIT', unit: currentUnit });
		}
		
	});
    
})();



// WEBPACK FOOTER //
// ./src/assets/scripts/service/unit-convert-service.js